import { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import MenuItem from "@mui/material/MenuItem";
import {
  MOBILE_NAV_LINKS,
  NAVIGATION_PATHS,
  homeToken,
} from "../../utils/constant";
import { useTranslation } from "react-i18next";
import {
  MobileNavLink,
  MobileNavigationMenuBox,
  MobileNavigationMenuIcon,
  MobileNavigationStyledMenu,
} from "./MobileNavigationMenu.styles";

const MobileNavigationMenu = () => {
  const { t } = useTranslation();
  const [anchorElNav, setAnchorElNav] = useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const mobileMenuCloseHandler = () => {
    setAnchorElNav(null);
  };

  return (
    <MobileNavigationMenuBox>
      <MobileNavigationMenuIcon
        size="large"
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleOpenNavMenu}
      >
        {anchorElNav ? <CloseIcon /> : <MenuIcon />}
      </MobileNavigationMenuIcon>
      <MobileNavigationStyledMenu
        id="menu-appbar"
        anchorEl={anchorElNav}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        open={Boolean(anchorElNav)}
        onClose={mobileMenuCloseHandler}
      >
        {MOBILE_NAV_LINKS.map((link) => (
          <MenuItem key={link} onClick={mobileMenuCloseHandler}>
            <MobileNavLink
              selected={window.location.pathname === NAVIGATION_PATHS[link]}
              to={NAVIGATION_PATHS[link]}
            >
              {t(homeToken[link])}
            </MobileNavLink>
          </MenuItem>
        ))}
      </MobileNavigationStyledMenu>
    </MobileNavigationMenuBox>
  );
};

export default MobileNavigationMenu;